import * as conf from './conf';
import { Utils__parseQuery, Utils__param, Utils__splitUrl, Utils__copy } from './utils';
import { api__weixin } from './api';

export const share__map = {
    wechat: '微信',
    qq: 'QQ',
    moment: '朋友圈',
    social: '二次分享',
};

function share__init(options) {
    const $script = document.createElement('script');

    $script.src = '//qzonestyle.gtimg.cn/qzone/qzact/common/share/share.js';
    document.body.appendChild($script);

    $script.addEventListener('load', () => {
        window.setShareInfo({
            title: options.title,
            summary: options.summary,
            pic: options.pic,
            url: options.url,
            // 微信权限验证配置信息，若不在微信传播，可忽略
            WXconfig: options.WXconfig,
        });
    });
}

function share__setUrl(params) {
    const typeMap = {
        'news': 'nativeNewsDetail',
        'atlas': 'atlasDetail',
        'video': 'videoDetail',
    };

    return conf.scheme + (typeMap[params.type] || typeMap['news']) + '?docId=' + params.docid;
}

function getBrowser() {
    const UA = navigator.userAgent || '';

    const isQQ = /\bV1_AND_SQI?_([\d\.]+)(.*? QQ\/([\d\.]+))?/.test(UA);

    const isWx = UA.match(/micromessenger/i) ? true : false;

    const browser = {
        isQQ: isQQ,
        isWx: isWx,
    };

    return browser;
}

/**
 * AppLink:H5唤起APP的所有方法
 */
class AppLink {
    constructor(config) {
        this.config = config || {};
    }

    go(url) {
        window.location.href = url;
    }

    checkOpen(callback) {
        let interval = null;
        let count = 0;

        interval = setInterval(() => {
            count++;

            if (window.hasLeft) {
                clearInterval(interval);
            } else if (count > 20) {
                callback(window.hasLeft);
                clearInterval(interval);
            }
        }, 50);
    }

    open() {
        const browser = getBrowser();

        // 微信直接跳应用宝
        if (browser.isWx) {
            this.go(this.config.appStore);
        } else if (browser.isQQ) {
            this.tryCallApp(this.config.scheme);
            // 唤起失败 跳到小米应用商店
            this.checkOpen((isSuccess) => {
                if (!isSuccess) {
                    this.go(this.config.miAppStore);
                }
            });
        } else {
            this.tryCallApp(this.config.scheme);
            // 唤起失败 跳到应用宝
            this.checkOpen((isSuccess) => {
                if (!isSuccess) {
                    this.go(this.config.appStore);
                }
            });
        }
    }

    tryCallApp(scheme) {
        const aLink = document.createElement('a');
        const body = document.body;

        aLink.href = scheme;
        body.appendChild(aLink);
        console.log('打开:' + aLink.href);
        aLink.click();
    }
}

export function share__wx(doc) {
    let url;
    let hostArr;
    let host;
    const title = doc.title;
    const pic = doc.image;
    const summary = `我分享了【${title}】，快来看吧！`;
    const urlArr = doc.url.split('?');
    const params = Utils__parseQuery(urlArr[1]);

    params.share = 'social';
    url = Utils__param(params, urlArr[0]);
    hostArr = /\.?(\w+\.\w+(?=\/))/.exec(url);
    host = hostArr ? hostArr[1] : '';

    const config = {
        title,
        summary,
        url,
        pic,
        WXconfig: {},
    }

    // 根据二级域名不同，取微信分享配置信息
    switch(host) {
        case '163yun.com':
            config.WXconfig = (window.__WX_CONFIG__ || {}).content;
            share__init(config);
            break;
        case 'miui.com':
            api__weixin((data) => {
                config.WXconfig = data;
                share__init(config);
            });
            break;
        default:
            share__init(config);
    }
}

export function share__open(url, copyedtext, opt = {}) {
    url = Utils__splitUrl(url || location.href);

    const params = Utils__parseQuery(url);
    // const source = params.source || 'news';
    // const channel = params.source === 'liulanqi' ? 'liulanqituwen.apk' : 'xiangkan_tuwen.apk';
    const ck = params.source === 'liulanqi' ? 'CK1430771235862' : 'CK1433533136477';
    let targetUrl = `http://a.app.qq.com/o/simple.jsp?pkgname=com.xiangkan.android&ckey=${ck}`;

    if (params.target !== 'home') { // 没有android_schema参数deeplink想看首页
        targetUrl += `&android_schema=${encodeURIComponent(share__setUrl(params))}`;
    }

    Utils__copy(copyedtext || (params.source === 'liulanqi' ? 'xiangkanSpread,share_news_llq' : 'xiangkanSpread,share_news'));

    // 10:29 统一跳转到应用宝
    window.location.href = targetUrl;
    console.log(opt);

    // window.location.href = `${conf.browserDownloadUrl}&title=${encodeURIComponent(opt.title)}&schema=${encodeURIComponent(share__setUrl(params))}&source=${source}&channel=${channel}`;
    /*
    const config = {
        scheme: share__setUrl(params),
        appStore: `${conf.appStore}&android_schema=${encodeURIComponent(share__setUrl(params))}`,
        miAppStore: conf.miAppStore,
    };
    const applink = new AppLink(config);

    applink.open();
    */
}

export function shareOpenAppStore() {
    const params = Utils__parseQuery(location.href);

    window.location.href = `${conf.appStore}&android_schema=${encodeURIComponent(share__setUrl(params))}`;
}
